﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const italianLabels: TranslationLabels = {
  Actions: "Actions",
  Actions_Add: "Aggiungere",
  Actions_Add_Board: "Aggiungere",
  Actions_AddBoard: "Creare",
  Actions_AddMeeting: "Aggiungere",
  Actions_AddMeeting_Submitting: "Creare riunione …",
  Actions_Back: "Di ritorno",
  Actions_Browse: "Sfogliare …",
  Actions_Cancel: "Annullare",
  Actions_Close: "Chiudere",
  Actions_Close_AriaLabel: "Chiudere",
  Actions_Copy_AgendaItem: "Copiare",
  Actions_Delete: "Cancellare",
  Actions_Delete_AgendaItem: "Cancellare",
  Actions_Delete_AgendaItem_Confirm: "Vuole davvero cancellare questo punto all'ordine?",
  Actions_Delete_AgendaItem_Pending: "Il punto all'ordine sarà cancellato …",
  Actions_Delete_Document: "Cancellare il documento",
  Actions_Delete_Document_Confirm: "Vuole davvero cancellare questo documento?",
  Actions_Delete_Document_Pending: "Il documento sarà cancellato …",
  Actions_Delete_Meeting: "Cancellare",
  Actions_Delete_Meeting_Confirm: "Si vuole davvero cancellare  questa riunione, compresi tutti i punti all'ordine, i partecipanti e compiti?",
  Actions_Delete_Meeting_Pending: "La riunione, compresi tutti i punti all'ordine, i partecipanti e compiti, viene cancellata …",
  Actions_Delete_Participant: "Cancellare",
  Actions_Delete_Participant_Confirm: "Volete davvero cancellare questi partecipanti?",
  Actions_Delete_Participant_Pending: "Il partecipante sarà cancellato …",
  Actions_Delete_Task_Confirm: "Volete davvero cancellare questo compito?",
  Actions_Delete_Task_Pending: "Il compito sarà cancellato …",
  Actions_Delete_Task_Title: "Cancellare il compito",
  Actions_DocumentsGrid_Tooltip: "Azione per la sincronizzazione",
  Actions_Download: "Scarica",
  Actions_Edit: "Modifica",
  Actions_Edit_AgendaItem: "Modifica del punto all'ordine",
  Actions_Edit_Meeting: "Modifica riunione",
  Actions_Edit_Participant: "Modifica partecipante",
  Actions_Edit_Task: "Modificare compito",
  Actions_EditSettings: "Modifica delle configurazioni",
  Actions_GoToBoard: "Alle configurazioni dell'organo",
  Actions_GoToMeetings: "Alle riunioni della organo",
  Actions_Help: "Aiuto",
  Actions_HideChildren: "Nascondi elementi subordinati",
  Actions_HideDiff: "Nascondi differenze",
  Actions_Indent_AgendaItem: "Aumentare l'indentazione",
  Actions_Move_AgendaItem: "Spostare",
  Actions_No: "No",
  Actions_None: "Nessuna",
  Actions_OneDriveMeetingFolder: "Aprire la cartella della riunione su OneDrive (disponibile solo al termine della sincronizzazione).",
  Actions_OneDriveSync: "Sincronizzare",
  Actions_OneDriveSync_Delete: "Cancellare",
  Actions_OneDriveSync_Failure: "Non è stato possibile eseguire la sincronizzazione con OneDrive, riprova.",
  Actions_OneDriveSync_Success: "La sincronizzazione con OneDrive è stata completata con successo.",
  Actions_OneDriveSyncFolder: "Aprire la cartella",
  Actions_Open: "Aprire",
  Actions_OpenPhonebook: "Aprire la rubrica telefonica",
  Actions_OpenUserProfile: "Aprire il profilo dell'utente",
  Actions_Outdent_AgendaItem: "Ridurre l'indentazione",
  Actions_Overwrite: "Sovrascrivere",
  Actions_Participant_Edit: "Modifica partecipante",
  Actions_Refresh: "Aggiorna",
  Actions_Reset: "Ripristinare",
  Actions_Retry: "Riprova",
  Actions_Save: "Salvare",
  Actions_SendTo_AgendaItem: "Inviare a",
  Actions_ShowChildren: "Mostra elementi subordinati",
  Actions_ShowDiff: "Mostra differenze",
  Actions_Submit: "Salvare",
  Actions_Synchronize: "Sincronizzare",
  Actions_ToggleDetails: "Mostra/nascondi i dettagli",
  Actions_View: "Dettagli",
  Actions_View_AgendaItems: "Aprire punti all'ordine",
  Actions_View_Documents: "Visualizza documenti",
  Actions_View_History: "Cronologia versioni",
  Actions_View_Meeting: "Aprire riunione",
  Actions_View_OneDriveSync: "Visualizza sincronizzazione OneDrive",
  Actions_View_Participants: "Aprire partecipanti",
  Actions_View_Tasks: "Aprire compito",
  Actions_Yes: "Sì",
  AddAgendaItemPosition: "Inserisci a",
  AddAgendaItemPosition_AfterSelected: "Dopo il selezionato",
  AddAgendaItemPosition_ContextHelp: "Scegli il punto in cui inserire il nuovo punto all’ordine del giorno. «Alla Fine» verrà attaccato alla fine della riunione. «Dopo il selezionato» verrà posto subito dopo l’attuale punto all’ordine del giorno. Se non è stato selezionato alcun punto all’ordine del giorno, viene aggiunto anche alla fine.",
  AddAgendaItemPosition_Last: "Alla fine",
  AddBoard_Label: "Aggiungi un organo",
  AddBoardPanel_Header: "Aggiungere organo",
  Added: "Aggiunto",
  AddGroupMember: "Aggiungi membro",
  AddMeeting_Description: "Definire qui il titolo della riunione (i dettagli possono essere personalizzati di seguito). Utilizzare il seguente formato: AAAA-MM-GG_abbreviazione riunione del organo (Esempio: 2019-08-12_Riunione KL).",
  AddMeeting_Title: "Aggiungi riunione",
  AddParticipant_Description: "Tutte le persone autorizzate del organo possono essere aggiunte come partecipanti alle riunioni.",
  AddParticipant_NoDataTemplate: "Partecipante non trovato. È possibile aggiungere altri partecipanti nelle impostazioni del organi.",
  AddParticipant_Placeholder: "Aggiungere un partecipante …",
  AddParticipant_Title: "Aggiungi partecipanti",
  AddUser: "Aggiungere",
  AddUser_Label: "Inserire untente",
  Admin: "Admin",
  AdminBoardsFilter_Placeholder: "Ricerca di organi …",
  AdminUsersFilter_Placeholder: "Ricerca di utenti …",
  AgendaItem: "Punto all'ordine",
  AgendaItem_Add_Submitting: "Creare un punto all'ordine …",
  AgendaItem_AdditionalInfo_Description: "-",
  AgendaItem_AdditionalInfo_Title: "Testo supplementare",
  AgendaItem_Confidential_Active_Tooltip: "Il punto all'ordine è strettamente confidenziale. I documenti di lavoro sono gestiti al di fuori dell'amministrazione della riunione e i verbali (strettamente confidenziali) sono distribuiti separatamente.",
  AgendaItem_Confidential_Description: "Si prega di annotare qui se il punto all'ordine è strettamente confidenziale. In questo caso, il documento deve essere inviato per e-mail e protocollato in un protocollo separato e strettamente riservato.",
  AgendaItem_Confidential_Inactive_Tooltip: "Questo punto all'ordine è confidenziale.",
  AgendaItem_Confidential_Title: "Strettamente confidenziale",
  AgendaItem_Confidential_Tooltip: "Strettamente confidenziale",
  AgendaItem_Decision_Description: "Indicare qui la proposta specifica per la risoluzione (da trasferire dal modello).",
  AgendaItem_Decision_Title: "Decisione",
  AgendaItem_Department_Description: "Inserire la sigla dell'unità responsabile del punto all'ordine. In linea di principio sempre da -1 a -2 livelli gerarchici. Ad esempio, \"F\", \"K-UE\", \"G\".",
  AgendaItem_Department_Title: "Unità responsabile (abbreviazione)",
  AgendaItem_Department_Tooltip: "Unità responsabile",
  AgendaItem_DocumentStatus_Description: "Mostra il numero di documenti assegnati al punto",
  AgendaItem_DocumentStatus_Title: "Documenti di lavoro",
  AgendaItem_DocumentStatus_Tooltip: "Documenti",
  AgendaItem_Duration_Description: "Inserire la durata prevista del punto all'ordine in minuti. Inserire sempre il tempo minimo concordato/necessario.",
  AgendaItem_Duration_Title: "Durata [min.]",
  AgendaItem_Duration_Tooltip: "Tempo necessario",
  AgendaItem_EdecideType_Description: "Il tipo di modello eDecide viene utilizzato per creare una attività eDecide. Il valore predefinito è vuoto. Solo le voci dell'agenda che contengono un tipo di modello != vuoto vengono trasferite a eDecide.",
  AgendaItem_EdecideType_Title: "Tipo di tema eDecide",
  AgendaItem_EdecideType_Tooltip: "Tipo di tema eDecide",
  AgendaItem_Edit: "Modificare",
  AgendaItem_EndTime_Description: "Il campo viene calcolato automaticamente in base all'ora di inizio della riunione e alla durata dei punti all'ordine.",
  AgendaItem_EndTime_Title: "Ora di fine",
  AgendaItem_FinalBoard_Description: "Indicare in questo campo il organo finale (sigla) con il tipo di modello (BV, IV, altro). Esempio: KL-BV, VR-IV, officina BPL.",
  AgendaItem_FinalBoard_Title: "Organo finale / Tipo di modello",
  AgendaItem_FinalBoard_Tooltip: "Organo finale / Tipo di modello",
  AgendaItem_FinalBoardDate_Title: "Data del organo finale",
  AgendaItem_Guests_Description: "Inserire qui gli ospiti per il punto all'ordine. I valori multipli possono essere separati da un punto e virgola <code>;</code> o da una nuova riga.",
  AgendaItem_Guests_Title: "Ospiti",
  AgendaItem_HeadingNumber_Description: "-",
  AgendaItem_HeadingNumber_Title: "No.",
  AgendaItem_Level_Description: "Campo interno, non viene visualizzato",
  AgendaItem_Level_Title: "Indentazione",
  AgendaItem_Locked_Active_Tooltip: "Il punto all'ordine è chiuso ai membri per la modifica.",
  AgendaItem_Locked_Description: "Bloccare qui il punto all'ordine se nessuno, oltre ai titolari del organo, deve modificare qualcosa.",
  AgendaItem_Locked_Inactive_Tooltip: "Il punto all'ordine è aperta ai membri per la modifica.",
  AgendaItem_Locked_Title: "Bloccato",
  AgendaItem_Locked_Tooltip: "Bloccato per la modifica dei membri",
  AgendaItem_Meeting_ContextHelp_Title: "Riunione",
  AgendaItem_NavBar_AddAgendaItem: "Aggiungere",
  AgendaItem_NavBar_MeetingIsTemplate: "La riunione è una riunione standard (alias modello) ed è bloccata per la modifica da parte dei membri.",
  AgendaItem_NavBar_MeetingLocked: "La riunione è bloccata per la modifica da parte dei membri.",
  AgendaItem_NavBar_SubmittedAgendaItems: "Punti all'ordine presentati",
  AgendaItem_NavBar_ToggleNav: "Mostra/nascondi la navigazione",
  AgendaItem_NavBar_ToggleView: "Seleziona le viste",
  AgendaItem_NavBar_View: "Vista",
  AgendaItem_New_Placeholder: "Nuovo punto …",
  AgendaItem_Note_Description: "Inserire qui ulteriori informazioni sul punto all'ordine.",
  AgendaItem_Note_Title: "Osservazioni",
  AgendaItem_Perusal_Description: "Indicare qui la proposta specifica di riconoscimento (da trasferire dal modello).",
  AgendaItem_Perusal_Title: "Riconoscimento",
  AgendaItem_Position_Description: "Campo interno, non viene visualizzato",
  AgendaItem_Position_Title: "Posizione",
  AgendaItem_ProtocolEntry_Description: "Testo della proposta dal modello Word con cui le aree presentano i punti all'ordine alla riunione. ev. = risoluzione. L'inserimento viene effettuato dalle aree",
  AgendaItem_ProtocolEntry_Title: "Inserimento del protocollo",
  AgendaItem_ProtocolEntryDraft_Description: "Voce di registro non visualizzata sull'iPAD.",
  AgendaItem_ProtocolEntryDraft_Title: "Voce di protocollo (bozza)",
  AgendaItem_Sortable: "-",
  AgendaItem_Sortable_Tooltip: "Le voci dell'agenda possono essere ordinate mediante trascinamento.",
  AgendaItem_Speakers_Title: "Ospiti (protocollo)",
  AgendaItem_StandardVersion_Title: "Versione standard",
  AgendaItem_StartTime: "-",
  AgendaItem_StartTime_Title: "Ora di inizio",
  AgendaItem_StartTime_Tooltip: "Ora d'inizio",
  AgendaItem_Status: "Stato",
  AgendaItem_Status_Description: "Stato del punto all'ordine. Puramente informativo.",
  AgendaItem_Status_Title: "Stato",
  AgendaItem_Title_Description: "Campo interno - Viene calcolato da Descrizione e abbreviato a un massimo di 255 caratteri",
  AgendaItem_Title_Title: "Titolo",
  AgendaItem_Type_Description: "Inserire il tipo.",
  AgendaItem_Type_Title: "Tipo",
  AgendaItems: "Punti da trattare",
  AgendaItems_Description: "Contiene i punti all'ordine del organo",
  AgendaItems_Loading: "Caricamento dei punti all'ordine …",
  AgendaItems_Loading_EditForm: "Caricamento il formulario per i punti all'ordine …",
  AgendaItems_Title: "Punti all'ordine",
  AgendaItemsDetail_Empty: "Selezionare un punto all'ordine",
  AgendaItemsList_Empty: "Non sono stati registrati punti all'ordine",
  AgendaItemStatus_Approved: "Deliberato",
  AgendaItemStatus_Archived: "Archiviato",
  AgendaItemStatus_Default: "In corso",
  AgendaItemStatus_Deleted: "Cancellato",
  AgendaItemStatus_Finalized: "Concluso",
  AgendaItemStatus_Itemized: "All'ordine",
  AgendaItemStatus_Published: "Pubblicato",
  AgendaItemStatus_Unknown: "Sconosciuto",
  AgendaItemType_Break: "Pausa",
  AgendaItemType_Category: "Categoria",
  AgendaItemType_Decision: "BV",
  AgendaItemType_Decision_eDecide: "BV - eDecide",
  AgendaItemType_Decision_Tooltip: "Modello decisione",
  AgendaItemType_Discussion: "Discussione",
  AgendaItemType_Empty: "Vuoto",
  AgendaItemType_Information: "IV",
  AgendaItemType_Information_eDecide: "IV - eDecide",
  AgendaItemType_Information_Tooltip: "Modello informativo",
  AgendaItemType_NoDataTemplate: "Nessun tipo trovato",
  AgendaItemType_Other: "Altro",
  AgendaItemType_Placeholder: "Selezionare il tipo …",
  All: "Tutti",
  ApplicationName: "SiVe",
  AuditLog: "Registro di audit",
  AuditLog_Action: "Action",
  AuditLog_Add: "Aggiunto",
  AuditLog_After: "Dopo",
  AuditLog_Before: "Prima",
  AuditLog_Changes: "Modifiche",
  AuditLog_Created: "Data",
  AuditLog_CreatedBy: "Utente",
  AuditLog_Date: "Su",
  AuditLog_Diff: "Differenze",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Campi",
  AuditLog_Property: "Campo",
  AuditLog_Remove: "Cancellato",
  AuditLog_State: "Azione",
  AuditLog_Update: "Modificato",
  AuditLog_User: "da",
  AuditLogs: "Registri di audit",
  Auth_Loading: "Caricamento dell'applicazione …",
  Auth_LoginFailed: "La verifica è fallita.",
  Auth_Redirecting: "Caricamento della verifica …",
  Auth_TryAgain: "Prova di nuovo.",
  Back: "Di ritorno",
  BackHome: "Torna alla pagina iniziale",
  BaseData: "Dati di base",
  BlobDocument: "Documento",
  Board: "Organi",
  Board_ArchivedDate: "Data di archiviazione",
  Board_BoardUniqueId: "Id del organo eDecide",
  Board_BoardUniqueId_Help: "L'id organoeDecide viene utilizzato per inviare le corse del organo corrente a eDecide. Questo ID può essere copiato in eDecide nella schermata gestisci organo. La funzione Invia a è attiva solo se è stato inserito un ID.",
  Board_BusinessOwner: "Persona responsabile",
  Board_BusinessOwner_Help: "La persona tecnicamente responsabile di questo organo lo ha originariamente istituito oppure lo ha rilevato da un precedente responsabile.",
  Board_ClearCache: "Svuotare la cache",
  Board_DefaultDuration: "Durata standard",
  Board_DefaultDuration_Help: "La durata predefinita viene aggiunta all'ora di inizio di ogni riunione  appena creata e determina l'ora di fine prevista.",
  Board_DefaultLocation: "Sede/sala riunioni",
  Board_DefaultLocation_Help: "Questo testo viene inserito come luogo/sala riunioni per ogni nuova riunione creata.",
  Board_DefaultRemarks: "Osservazioni",
  Board_DefaultRemarks_Help: "Questo testo viene inserito come commento per ogni nuova riunione creata.",
  Board_DefaultTime: "Ora di inizio hh:mm",
  Board_DefaultTime_Help: "L'ora viene utilizzata come orario di inizio suggerito per ogni nuova riunione creata.",
  Board_Description: "Descrizione",
  Board_Description_Help: "-",
  Board_DownloadConfig: "Scarica la configurazione",
  Board_DownloadConfig_Tooltip: "Scaricare l'elenco di configurazione come file zip",
  Board_DownloadUsers: "Scarica l'elenco degli utenti",
  Board_DownloadUsers_Tooltip: "Scaricare l'elenco degli utenti come file CSV",
  Board_EdecideId: "Id del cieDecide",
  Board_EdecideId_Help: "L'id organo eDecide viene utilizzato per inviare le corse del organo corrente a eDecide. Questo ID può essere copiato in eDecide nella schermata gestisci organo. La funzione Invia a è attiva solo se è stato inserito un ID.",
  Board_Id: "Id",
  Board_Id_Help: "La chiave del database dell'organo",
  Board_LongName: "Nome lungo",
  Board_LongName_Help: "Il nome lungo viene utilizzato nei modelli di documento e nell'interfaccia utente della gestione delle riunioni. I valori usuali sono il nome completo del organo, come Consiglio di amministrazione o Direzione del gruppo.",
  Board_Name: "Nome interno",
  Board_Name_Help: "Il nome interno viene utilizzato come nome univoco dell’organo nella barra degli indirizzi del browser (URL). Se un nome interno viene modificato, i nomi interni precedenti rimangono associati all’organo e rimangono nel sistema.",
  Board_NameHistories_Title: "Nome precedente",
  Board_OrganisationUnit: "Unità organizzativa",
  Board_OrganisationUnit_Help: "L'unità organizzativa che è tecnicamente responsabile di questo organo corrisponde di norma alla persona incaricata.",
  Board_Settings: "Configurazione del organo",
  Board_ShortName: "Nome breve",
  Board_ShortName_Help: "Il nome breve del organo viene utilizzato nei modelli di documento e nell'interfaccia utente di gestione delle riunioni. I valori usuali sono un'abbreviazione del organo, come VR (Consiglio di amministrazione), KL (Direzione del gruppo)",
  Board_SignatureFirstName: "Nome della firma",
  Board_SignatureFirstName_Help: "Il nome della firma può essere inserito quando si generano e-mail, verbali e inviti.",
  Board_SignatureLastName: "Cognome della firma",
  Board_SignatureLastName_Help: "Il cognome della firma può essere inserito quando si generano e-mail, verbali e inviti.",
  Board_Status: "Stato",
  Board_Status_Help: "Lo stato del organo riflette il ciclo di vita in SiVe. I organi eliminati non vengono più visualizzati nel dashboard.",
  Board_Update_Error: "Non è stato possibile salvare il organo: {0}",
  Board_Update_Success: "Il organo è stato salvato",
  BoardMemberships: "Autorizzazioni",
  BoardPicker_Placeholder: "Inserire un termine di ricerca dell'organo …",
  Boards: "Organi",
  BoardSettings: "Configurazione del organo",
  BoardSettings_MeetingDefaults: "Valori predefiniti per le riunioni",
  BoardSettings_StandardMeetingOldOnly: "Le seguenti impostazioni vengono utilizzate solo quando si applica la riunione standard «{0}».",
  BoardStatus_Active: "Attivo",
  BoardStatus_Archived: "Archiviato",
  BoardStatus_Deleted: "Cancellato",
  BoardStatus_Draft: "Bozza",
  BoardStatus_Unknown: "Sconosciuto",
  BoardTemplate_Delete_Error: "Impossibile eliminare il modello: {0}",
  BoardTemplate_Delete_Success: "Il modello è stato eliminato",
  BoardTemplate_Upload_Error: "Non è stato possibile caricare il modello: {0}",
  BoardTemplate_Upload_Success: "Il modello è stato caricato con successo",
  BoardTemplate_UploadTitle: "Carica il modello",
  BoardTemplates_Description: "Questi modelli sono stati personalizzati per la scheda attuale. Contattare egpl@sbb.ch se si ha bisogno di aiuto per la configurazione.",
  BoardTemplates_Title: "Modelli dell'organo",
  BoardUnique: "ID univoco",
  BusinessOwner: "Titolare",
  ButtonHelp: "Aiuto",
  By: "da",
  ClaimIssuer: "Emittente di rivendicazioni",
  Claims: "Rivendicazioni dell'utente",
  ClaimType: "Tipo di rivendicazion",
  Confirm_Accept: "SI",
  Confirm_Cancel: "Cancellare",
  Confirm_Content: "Sono state rilevate modifiche non salvate. Vuoi davvero ignorarle?",
  Confirm_Discard: "Scartare le modifiche",
  Confirm_Title: "Modifiche non salvate",
  ContextHelp: "Aiuto",
  ContextHelp_Fallback_Content: "Non è stato inserito alcun aiuto contestuale per l'argomento {0}.",
  ContextHelp_Fallback_Title: "Aiuto",
  ContextHelp_TemplateId_Description: "Gli attributi della riunione standard selezionata (riunione, punti all'ordine del giorno, partecipanti) vengono adottati quando viene creata la nuova riunione. Se si seleziona vuoto, viene creata solo la sessione e gli elementi dell'ordine del giorno e i partecipanti possono essere utilizzati in seguito.",
  ContextHelp_TemplateId_Title: "Selezione della riunione standard",
  CopyToClipboard: "Copia negli appunti",
  CopyToClipboard_Idle: "Copia negli appunti…",
  CopyToClipboard_Success: "Copia!",
  Created: "Creato",
  Dashboard_Button_OwnerExport: "Scarica l'elenco non filtrato",
  Dashboard_Button_UserExport: "Scarica l'elenco filtrato",
  Dashboard_EmptyTable: "Non sono state trovate riunioni che corrispondono ai criteri richiesti.",
  Dashboard_Filter_Tasks: "Solo i miei compiti",
  Dashboard_Grid_Header_EndDate: "Data di consegna",
  Dashboard_Grid_Header_Meeting: "Riunione",
  Dashboard_Grid_Header_StartDate: "Data inizio",
  Dashboard_Loading: "Caricamento delle riunioni …",
  Dashboard_Meeting_PlannedEndTime: "Orario di fine previsto",
  Dashboard_Meeting_ProjectedEndTime: "Orario di fine effettivo",
  Dashboard_Meeting_Tooltip: "Numero di riunioni a partire dalla data selezionata",
  Dashboard_Navbar_DetailedDashboard: "Aprire il dashboard dettagliato",
  Dashboard_Navbar_Edecide: "Aprire eDecide",
  Dashboard_Toggle_MyCommittees: "I miei organi",
  Dashboard_Toggle_Tasks: "Visualizzare compiti",
  Date_Unknown: "Sconosciuto",
  DateFilterBar_Dashboard_Description: "Nella dashboard vengono visualizzate le prossime riunioni di tutte le organi in cui si è autorizzati. Il periodo di visualizzazione (impostazione predefinita da oggi -14 giorni) può essere modificato utilizzando il filtro data. Tutte le organi e le riunioni visualizzate possono essere richiamate facendo clic su di esse.",
  DateFilterBar_Dashboard_Title: "Filtro data",
  DateFilterBar_Meetings_Description: "Il periodo di visualizzazione (impostazione predefinita da oggi -14 giorni) può essere modificato utilizzando il filtro data.",
  DateFilterBar_Meetings_Title: "Filtro data",
  DateFilterBar_ShowMeetings: "Mostra le riunioni dall'",
  DefaultDuration: "Durata",
  DefaultLocation: "Seda",
  DefaultRemarks: "Osservazioni",
  DefaultTemplates_Description: "La configurazione standard dell'applicazione viene installata insieme all'applicazione dal team di sviluppo SiVe. Le correzioni ai modelli vengono quindi aggiornate automaticamente per tutti i organi.",
  DefaultTemplates_Title: "Modelli",
  DefaultTime: "Ora di inizio",
  Deleted: "Cancellato",
  DeputyMember: "Membri aggiunti",
  DeputyVisitor: "Visitatori aggiunti",
  Description: "Descrizione",
  DismissableDialog_Close_Label: "Chiudere",
  DismissableDialog_Close_Tooltip: "Non visualizzare più il messaggio",
  Document_Action_Title: "Azione",
  Document_Add_Uploading: "Il documento è in fase di caricamento …",
  Document_Confidential_Title: "Strettamente confidenziale",
  Document_FileSize_Title: "Dimensione",
  Document_Modified_Title: "Modificato",
  Document_Modified_Tooltip: "Data di modifica del punto o del documento all'ordine",
  Document_Title_Title: "Titolo",
  Document_Title_Tooltip: "Nome del punto all'ordine o del file",
  Documents_Loading: "Caricamento dei documenti …",
  Documents_NavBar_Refresh: "Aggiornare",
  Documents_NavBar_Sync_Description: "Nella colonna Azione, selezionare un'azione per i punti dell'ordine o per i singoli documenti ed eseguirla con il pulsante Sincronizza",
  Documents_NavBar_Sync_Submitting: "Sincronizzazione dei file …",
  Documents_NavBar_Sync_Title: "Aiuto per Sincronizzazione",
  Documents_NavBar_ToggleNav: "Mostra/nascondi la navigazione",
  Documents_NavBar_View: "Vista",
  Documents_Refreshing: "Aggiornamento dei documenti …",
  Documents_Secret: "Documenti aggiuntivi",
  DocumentsForm_None: "nessuno",
  DocumentsList_Empty: "Non sono stati registrati punti all'ordine.",
  DocumentsPanel_Description: "Per questo punto all'ordine del giorno sono stati caricati i seguenti file",
  DocumentsPanel_Header: "Documenti",
  DocumentsPanel_Loading: "Caricamento dei documenti …",
  DocumentStatus_Default: "Attivo",
  DocumentStatus_Deleted: "Cancellato",
  Edecide: "eDecide",
  Edecide_NoBoardLinked: "Il organo non è collegato a una organo eDecide.",
  Edecide_RunManagementUrl: "Modifica attività",
  Edecide_RunUrl: "Dettagli della attività",
  EdecidePanel_CreateRun_Failure: "Non è stato possibile creare una attività.",
  EdecidePanel_CreateRun_Failure_NotFound: "La organo eDecide non esiste. Controllare l'Id della organo eDecide nelle impostazioni.",
  EdecidePanel_CreateRun_Success: "Attività creata",
  EdecidePanel_DuplicateRuns: "Attività esistenti trovate",
  EdecidePanel_DuplicateRuns_Text: "Con questo ID esterno esiste almeno un corso eDecide. Se si devono trasferire nuovamente i dati da Sive, i duplicati andrebbero prima cancellati.",
  EdecidePanel_Header: "Attività eDecide",
  EdecidePanel_Loading: "Caricamento dell'anteprima …",
  EdecidePanel_OverrideTitle: "Titolo",
  EdecidePanel_OverrideTitle_HelpContent: "Il titolo del corso da creare in eDecide può essere sostituito in questo campo. Ciò dovrebbe essere necessario solo in casi eccezionali. La verifica di eventuali duplicati non viene effettuata tramite il titolo, ma tramite l’ID esterno.",
  EdecidePanel_OverrideTitle_HelpTitle: "Sostituire il titolo",
  EdecidePanel_Participant_Name: "Nome",
  EdecidePanel_Participants: "Partecipanti",
  EdecidePanel_Submit: "Crea attività",
  EdecidePanel_Submitting: "Creazione della attività in eDecide …",
  EdecidePanel_Topic_Title: "Titolo",
  EdecidePanel_Topic_Type: "Tipo",
  EdecidePanel_Topics: "Punti all'ordine (temi)",
  EdecidePanel_UniqueId: "ID esterno",
  EdecideStatus_CompleteRunFailure: "Non è stato possibile completare l'attività.",
  EdecideStatus_CompleteRunSuccess: "Attività completata con successo.",
  EdecideStatus_CompletingRun: "L'esecuzione viene completata …",
  EdecideStatus_CreateRunFailure: "Non è stato possibile creare l'attività.",
  EdecideStatus_CreateRunSuccess: "L'attività è stata creata con successo",
  EdecideStatus_CreatingRun: "La attività viene creata…",
  EdecideStatus_Empty: "Non è stata avviata nessuna attività.",
  EdecideType_Decision: "Decisione",
  EdecideType_Decision_Tooltip: "Questo punto all'ordine è presentato a eDecide come Decisione",
  EdecideType_Default: "-",
  EdecideType_Information: "Informazione",
  EdecideType_Information_Tooltip: "Questo punto all'ordine sarà inviato a eDecide come argomento informativo",
  EditAgendaItemPanel_Header: "Modifica del punto all'ordine",
  EditBoardPanel_Header: "Modifica organo",
  EditMeetingPanel_Header: "Modifica riunione",
  EditParticipantPanel_Header: "Modifica partecipante",
  EditTaskPanel_Header: "Modificare compito",
  Email: "E-mail",
  EmptyTable: "Nessun dato presente nella tabella",
  Entity: "Entità",
  Entity_Add_Failure: "Non è stato possibile creare {EntityName}.",
  Entity_Add_Success: "{EntityName} è stata creata con successo.",
  Entity_Delete_ConfirmContent: "Si vuole davvero cancellare {EntityName}?",
  Entity_Delete_ConfirmTitle: "Confermare l'eliminazione",
  Entity_Delete_Failure: "Non è stato possibile eliminare {EntityName}.",
  Entity_Delete_Success: "{EntityName} cancellato con successo.",
  Entity_IsDeleted_Description: "Questo record di dati è eliminato (stato: Cancellato). Il record di dati può di norma essere riattivato impostando un altro stato da cancellato.",
  Entity_IsDeleted_Title: "È cancellato",
  Entity_Patch_Failure: "La sua richiesta non è stata elaborata, la preghiamo di riprovare.",
  Entity_Patch_SuccessNoChanges: "La richiesta è stata elaborata, ma non è stata riconosciuta alcuna modifica.",
  Entity_Patch_Unauthorized: "Non siete autorizzati a effettuare questa regolazione.",
  Entity_Refresh_Failure: "Non è stato possibile ricaricare {EntityName}.",
  Entity_Refresh_Success: "{EntityName} ricaricato con successo.",
  Entity_Save_Failure: "Non è stato possibile salvare {EntityName}.",
  Entity_Save_Success: "{EntityName} salvato con successo.",
  Entity_Update_Failure: "Non è stato possibile aggiornare {EntityName}.",
  Entity_Update_Success: "{EntityName} aggiornato con successo.",
  EntityCount: "# Voci",
  EntityTitle_Unknown: "Sconosciuto",
  Error_FailedToAddUser: "Non è stato possibile aggiungere l'utente '{0}'.",
  ErrorCodes_BadRequest: "Qualcosa non ha funzionato nella query. Si tratta di un errore del client (ad esempio: sintassi della richiesta errata, inquadratura non valida del messaggio di richiesta o instradamento della richiesta fuorviante).",
  ErrorCodes_InternalServerError: "Si è verificato un errore durante l'elaborazione della tua richiesta.",
  ErrorCodes_NoResponse: "Il servizio di backend non è disponibile.",
  ErrorCodes_NotFound: "La risorsa non è stata trovata.",
  ErrorCodes_Unauthorized: "Non hai i permessi per accedere alla risorsa.",
  ErrorDialog_AppInsights: "Le seguenti proprietà possono essere utilizzate per analizzare l'errore che si è verificato in App Insights nel portale Azure (Indagine > Ricerca > Filtro). Aggiungere queste proprietà al momento della creazione dell'incidente.",
  ErrorDialog_AppInsights_Date: "Tempistica",
  ErrorDialog_AppInsights_OperationId: "Operazione",
  ErrorDialog_AppInsights_SessionId: "Riunione",
  ErrorDialog_AppInsights_UserId: "Utente",
  ErrorDialog_AuthFailure_Text: "Durante l'esecuzione della richiesta si è verificato un errore di autenticazione. Ricaricare la pagina e riprovare.",
  ErrorDialog_AuthFailure_Title: "Errore di autenticazione",
  ErrorDialog_ComponentFailure_Text: "Si è verificato un errore nell'interfaccia utente. Controllare il messaggio di errore nella console del browser (F12).",
  ErrorDialog_ComponentFailure_Title: "Errore dell'interfaccia utente",
  ErrorDialog_ForbiddenFailure_Text: "Non si dispone dei diritti di accesso per eseguire questa azione o per accedere a questa risorsa.",
  ErrorDialog_ForbiddenFailure_Title: "Accesso negato",
  ErrorDialog_NotFoundFailure_Text: "Il record di dati non è stato trovato. È possibile che nel frattempo sia stato eliminato da un altro utente o che sia stata utilizzata una combinazione non valida di parametri. Riprova.",
  ErrorDialog_NotFoundFailure_Title: "Non trovato",
  ErrorDialog_OneDrive_Text: "A general OneDrive error has occurred. Contact IT support.",
  ErrorDialog_OneDrive_Title: "Errore OneDrive",
  ErrorDialog_OneDriveMissingSource_Title: "Errore OneDrive",
  ErrorDialog_OneDriveNotFound_Text: "OneDrive non è disponibile per il vostro account. Contattare l'assistenza IT.",
  ErrorDialog_OneDriveNotFound_Title: "Errore OneDrive",
  ErrorDialog_OneDrivePermissionsDenied_Text: "Non siete un partecipante a questa riunione, quindi questa funzione non è disponibile per voi.",
  ErrorDialog_OneDrivePermissionsDenied_Title: "Nessun diritto di sincronizzazione su OneDrive",
  ErrorDialog_ServerFailure_Text: "Durante l'esecuzione della richiesta si è verificato un errore del server. Aggiornare la pagina e riprovare.",
  ErrorDialog_ServerFailure_Title: "Errore del server",
  ErrorDialog_UnknownFailure_Text: "Si è verificato un errore sconosciuto durante l'esecuzione della richiesta. Ricaricare la pagina e riprovare.",
  ErrorDialog_UnknownFailure_Title: "Errore sconosciuto",
  Exception: "Eccezione",
  Exists: "Già presente",
  Extended_Mode: "Modalità estesa",
  File: "File",
  FileAction_Delete: "Verrà cancellato",
  FileAction_Existing: "Esistente",
  FileAction_New: "Verrà caricato",
  FileAction_Overwrite: "Verrà sovrascritto",
  FileCount_Tooltip: "Numero di documenti",
  FileName: "Nome del file",
  FileSize: "Dimensione del file",
  Filter_Combobox_Filter_Customize: "Filtro",
  Filter_Keywords_Description: "Cercare le parole chiave nella tabella",
  FilterToggle_ShowAgendaItems: "Mostra pti. trattare",
  FilterToggle_ShowAgendaItems_Description: "Visualizza l’ordine del giorno di organi e riunioni aperti.",
  FilterToggle_ShowAgendaItems_Title: "Mostra pti. trattare",
  FirstName: "Nome",
  FolderName: "Cartella",
  Footer_Help: "Aiuto",
  Footer_HelpTitle: "SBB eDecide Aiuto",
  Footer_Imprint: "Impronta",
  Footer_Support: "Supporto",
  Footer_Title: "Impronta e aiuto",
  GeneratedDocuments_Description: "Contiene i documenti generati dal organo (menu di output)",
  GeneratedDocuments_Title: "Documenti generati",
  GeneratorVariable_AgendaItem: "Punto all'ordine del giorno",
  GeneratorVariable_NoAgendaItems: "Nessun punto all'ordine del giorno trovato",
  GeneratorVariable_Nr: "No.",
  GeneratorVariable_ParticipantWithRoleNotFound: "Non è stato trovato alcun partecipante con il ruolo '{0}'!",
  GeneratorVariable_SeeConfidentialProtocol: "Vedi verbale (strettamente riservato)",
  GeneratorVariable_When: "Quando",
  GeneratorVariable_Who: "Chi",
  GridWorksConfig_Description: "Contiene la configurazione e i modelli del organo",
  GridWorksConfig_Title: "Configurazione",
  Group: "Gruppo",
  Group_Add: "Aggiungi gruppo",
  Group_AddError: "Impossibile aggiungere un gruppo",
  Group_AddSuccess: "Il gruppo è stato aggiunto con successo",
  Group_CleanupDeletedUsers: "Il gruppo contiene {0} utenti eliminati, si prega di rettificare questi inserimenti!",
  Group_ConfirmDelete: "Volete davvero cancellare il gruppo?",
  Group_DeleteError: "Non è stato possibile cancellare il gruppo",
  Group_EntraIdName: "Nome nell’Entra ID",
  Group_EntraIdName_Description: "Collegando qui un gruppo Entra ID Group (Omada), i membri vengono importati periodicamente. Se non è definito alcun collegamento, i membri a destra possono essere eliminati e aggiunti.",
  Group_Id: "Id",
  Group_MemberCount: "# Membri",
  Group_Members: "Membri",
  Group_Name: "Nome",
  Group_Search: "Gruppo di ricerca …",
  Group_SearchStringHint: "È il nome del gruppo AD supportato.",
  Group_Titles: "Gruppi di annunci",
  GroupMember_ExistsInGroup: "Esiste nel gruppo",
  Groups: "Gruppi",
  Header_English: "English",
  Header_French: "Français",
  Header_German: "Deutsch",
  Header_Help: "Aiuto",
  Header_Italian: "Italiano",
  Header_SettingsMenu: "Configurazioni",
  Header_SettingsMenu_Cache: "Visualizza la cache",
  Header_SettingsMenu_EditBoard: "Modifica delle configurazioni",
  Header_SettingsMenu_ViewBoard: "Visualizza le configurazioni",
  Header_UserMenu: "Utente corrente",
  Header_UserMenu_OneDrive: "OneDrive",
  Header_UserMenu_Profile: "Il mio account",
  Header_UserMenu_SignOut: "Disconnessione",
  Header_Version: "Version",
  Help: "Aiuto",
  HelpMenu_CosProductPage: "Prodotto COS eGPL 2",
  HelpMenu_Manuals: "Manuali",
  HelpMenu_Support: "Supporto",
  HelpMenu_VivaEngage: "Gruppo Viva Engage eGPL 2",
  History: "Storico",
  Home: "Home",
  Id: "Id",
  ImportedFromPhonebook: "Campi importati dalla rubrica telefonica",
  Info: "Vista da _START_ a _END_ di _TOTAL_ elementi",
  InfoFiltered: "(filtrati da _MAX_ elementi totali)",
  Initials: "Iniziali",
  Initials_HelpText: `Se lasci il campo vuoto, verrà applicato il valore predefinito.<br/>
Prima lettera del nome, prima lettera del cognome.`,
  Initials_Preview: "Anteprima",
  KendoReactGrid_CalendarToday: "Oggi",
  KendoReactGrid_FilterAfterOperator: "È dopo",
  KendoReactGrid_FilterAfterOrEqualOperator: "E' uguale o superiore a",
  KendoReactGrid_FilterBeforeOperator: "È prima",
  KendoReactGrid_FilterBeforeOrEqualOperator: "È prima o uguale a",
  KendoReactGrid_FilterBooleanAll: "(Tutti)",
  KendoReactGrid_FilterContainsOperator: "Contiene",
  KendoReactGrid_FilterDoesNotContain: "Non contiene",
  KendoReactGrid_FilterEndWith: "Termina con",
  KendoReactGrid_FilterEqOperator: "Pari",
  KendoReactGrid_FilterGteOperator: "È maggiore o uguale a",
  KendoReactGrid_FilterGtOperator: "È maggiore di",
  KendoReactGrid_FilterIsEmpty: "È vuoto",
  KendoReactGrid_FilterIsFalse: "E' falso",
  KendoReactGrid_FilterIsNotEmpty: "Non è vuoto",
  KendoReactGrid_FilterIsNotEqualTo: "Non uguale a",
  KendoReactGrid_FilterIsNotNull: "Non è nullo",
  KendoReactGrid_FilterIsNull: "È nullo",
  KendoReactGrid_FilterIsTrue: "E' vero",
  KendoReactGrid_FilterLteOperator: "È inferiore o uguale a",
  KendoReactGrid_FilterLtOperator: "È inferiore a",
  KendoReactGrid_FilterStartsWith: "Inizia con",
  KendoReactGrid_NoRecords: "Nessuna voce disponibile.",
  KendoReactGrid_PagerInfo: "{0} - {1} di {2} voci",
  KeywordSearch: "Ricerca per parole chiave",
  Language: "Lingua",
  LastModified: "Ultima modifica",
  LastModifiedBy: "Ultima modifica da",
  LastName: "Cognome",
  LastSync: "Ultima sincronizzazione",
  Loading: "Caricamento …",
  Loading_MeetingTemplates: "Caricamento le riunioni standard …",
  Logout: "Uscire",
  LongName: "Nome lungo",
  Meeting: "Riunione",
  Meeting_AdditionalInfo_Description: "Testo o link per ulteriori informazioni",
  Meeting_AdditionalInfo_Title: "Altre informazioni",
  Meeting_AgendaItems_Warning_Tooltip: "Punti all'ordine della riunione standard è stato aggiornato. Lo standard può essere applicato a questa riunione con Aggiorna punti all'ordine.",
  Meeting_Difference_Title: "Differenza",
  Meeting_DocumentStatus_ContextHelp_Title: "Documenti di lavoro",
  Meeting_DocumentStatus_Description: "Mostra il numero di documenti assegnati alla riunione",
  Meeting_DocumentStatus_Title: "Documenti di lavoro",
  Meeting_Duration_Title: "Tempo necessario",
  Meeting_EdecideStatus_Description: "-",
  Meeting_EdecideStatus_RunManagementUrl: "Collegamento 'Modifica attività' in eDecide",
  Meeting_EdecideStatus_RunUrl: "Collegamento a 'Dettagli della attività' in eDecide",
  Meeting_EdecideStatus_Status: "Stato della attività in SiVe/eDecide",
  Meeting_EdecideStatus_Title: "Stato eDecide",
  Meeting_EndDate_Description: "Inserire la data e l'ora di fine della riunione. L'ora di fine corrisponde a un valore pianificato. Questo viene confrontato con l'ora di fine effettiva. Se il tempo pianificato viene superato, sul display di utilizzo compare un semaforo rosso, mentre se il tempo pianificato non viene raggiunto compare un semaforo verde.",
  Meeting_EndDate_Title: "Fine prevista",
  Meeting_EventDate: "Data",
  Meeting_EventDate_Description: "Inserire la data e l'ora di inizio della riunione. Gli orari di inizio dei punti all'ordine vengono calcolati automaticamente.",
  Meeting_EventDate_Title: "Data",
  Meeting_EventTime_Title: "Orario d'inizio previsto",
  Meeting_IssueDate_Description: "In questo campo viene specificata la data di presentazione dei documenti per la riunione.",
  Meeting_IssueDate_Title: "Data di emissione",
  Meeting_IsTemplate: "È standard",
  Meeting_IsTemplate_Description: "Trasforma la riunione corrente in una riunione predefinita, in modo che possa essere utilizzata come modello per la creazione di nuove riunioni. Se la riunione è una riunione predefinita, è possibile riportarla allo stato di riunione normale.",
  Meeting_IsTemplate_Title: "È standard",
  Meeting_Loading: "Caricamento della riunione …",
  Meeting_Loading_EditForm: "Caricamento il formulario della riunione …",
  Meeting_Location_Description: "Si prega di specificare la sede della riunione e la sala. Ordine: nome della sala, piano, no. civico, codice postale, città",
  Meeting_Location_Title: "Sede/sala riunioni",
  Meeting_Locked_Active_Tooltip: "La riunione è chiusa ai membri per la modifica.",
  Meeting_Locked_Description: "Se necessario, bloccare la riunione qui. Quando è Bloccato, nessuno può inserire un punto all'ordine del giorno. Particolarmente indicato per le riunioni di riserva o per la pianificazione e la gestione aziendale.",
  Meeting_Locked_Inactive_Tooltip: "La riunione è aperta ai membri per la modifica.",
  Meeting_Locked_Title: "Bloccato",
  Meeting_New_Placeholder: "Nuova riunione …",
  Meeting_Note_Description: "Indicare qui le informazioni importanti/superiori alla riunione, par esempio La riunione si svolge extra muros.",
  Meeting_Note_Title: "Osservazione",
  Meeting_PlannedEndTime_Title: "Orario di fine previsto",
  Meeting_ProjectedEndTime: "Orario di fine effettivo",
  Meeting_ProjectedEndTime_Description: "-",
  Meeting_ProjectedEndTime_Title: "Orario di fine effettivo",
  Meeting_Status_Description: "Annotare lo stato della riunione in questo campo",
  Meeting_Status_Title: "Stato",
  Meeting_SubmissionDate_Description: "Inserire qui la data di presentazione dei documenti da inviare.",
  Meeting_SubmissionDate_Title: "Data di consegna",
  Meeting_TemplateId_Title: "Riunione standard",
  Meeting_Title_Description: "Si prega di utilizzare il seguente formato: JJJJ-MM-TT_abbreviazione riunione del organo (Esempio: 2019-08-12_KL-Riunione).",
  Meeting_Title_Title: "Titolo",
  Meeting_UpdateParticipants_Warning_Tooltip: "I partecipanti alla riunione standard sono stati aggiornati. Lo standard può essere applicato a questa riunione con Aggiorna partecipanti.",
  Meeting_WorkingDocumentStatus_Title: "Documenti di lavoro",
  Meeting_WorkingDocumentUrl_Description: "-",
  MeetingParticipants_Description: "Contiene i partecipanti alle riunioni",
  Meetings: "Riunioni",
  Meetings_Description: "Contiene le riunioni",
  Meetings_EmptyTable: "Non sono state trovate riunioni che corrispondono ai criteri richiesti.",
  Meetings_Loading: "Caricamento le riunione …",
  Meetings_Title: "Riunioni",
  MeetingStatus_Archived: "Archiviato",
  MeetingStatus_Complete: "Concluso",
  MeetingStatus_Default: "In corso",
  MeetingStatus_Deleted: "Cancellato",
  MeetingStatus_Published: "Pubblicato",
  MeetingStatus_Unknown: "Sconosciuto",
  Member: "Membro",
  Modified: "Modifica",
  ModifiedBy: "Modificato da",
  More: "Più",
  MoreEntries: "({0} voci)",
  MultiSelect_AllSelected: "Tutti selezionati",
  MultiSelect_FilterPlaceholder: "Filtrare…",
  MultiSelect_NoneSelected: "Nessuna selezione",
  MultiSelect_Reset: "Annulla selezione",
  MultiSelect_SelectAll: "Seleziona tutti",
  MultiSelect_Selected: "selezionato",
  MyRoles: "I miei ruoli",
  Name: "Nome",
  Navigation_Administration: "Amministrazione",
  No: "No",
  NoTitle: "Nessun titolo",
  OneDrive_Sync_Mismatch: "Sono disponibili documenti che non sono ancora stati pubblicati per la sincronizzazione.",
  OneDriveDocument: "Documento OneDrive",
  OneDriveSync_RemoteDocumentExistsUseOverwrite: "Il file OneDrive esiste già per {0}, selezionare «Overwrite» (Sopra) nel menu a discesa delle azioni per sostituirlo.",
  OneDriveSync_RemoteFileNotUploaded: "Non è stato possibile caricare il documento {0}. Errore: {1}",
  OneDriveSync_WorkingDocumentContentNotFound: "Non è stato possibile caricare i contenuti {0}!",
  OneDriveSync_WorkingDocumentDoesNotExist: "Il documento di lavoro {0} non esiste!",
  OpenLinkNewWindow: "Aprire il link (in una nuova finestra)",
  OrganisationUnit: "Unità organizzativa",
  OriginalPath: "Percorso richiesta",
  OutputDocument: "Documento di uscita",
  OutputDocument_AgendaItemConfirmedMail_Description: "Crea un modello di Outlook con cui informare il mittente dell'approvazione di una voce dell'agenda presentata",
  OutputDocument_AgendaItemConfirmedMail_Title: "Conferma il punto all'ordine",
  OutputDocument_AgendaItemDeferredMail_Description: "Crea un modello di Outlook con cui informare il mittente che una voce dell'ordine del giorno presentata è stata rinviata",
  OutputDocument_AgendaItemDeferredMail_Title: "Posticipare il punto all'ordine",
  OutputDocument_AgendaItemProtocolExtract_Description: "Crea l'estratto del protocollo in formato Word",
  OutputDocument_AgendaItemProtocolExtract_Title: "Creare un estratto di protocollo",
  OutputDocument_AgendaItemProtocolExtractMail_Description: "Crea un modello di Outlook per la voce dell'agenda selezionata, con l'estratto del verbale in formato PDF",
  OutputDocument_AgendaItemProtocolExtractMail_Title: "Inviare un estratto del protocollo",
  OutputDocument_AgendaItemProtocolExtractPdf_Description: "Crea l'estratto del registro in formato PDF",
  OutputDocument_AgendaItemProtocolExtractPdf_Title: "Creare un estratto di protocollo",
  OutputDocument_ApplyStandardMeeting_Description: "Selezionare una riunione standard e applicarla alla riunione esistente.",
  OutputDocument_ApplyStandardMeeting_Title: "Applicare la riunione standard",
  OutputDocument_Description: "Descrizione del documento di uscita",
  OutputDocument_Language: "Lingua",
  OutputDocument_Language_All: "Tutti",
  OutputDocument_Language_None: "Nessuno",
  OutputDocument_MeetingAgendaItems_Description: "Crea una panoramica dell'agenda in formato Excel",
  OutputDocument_MeetingAgendaItems_Title: "Creare una panoramica dell'agenda",
  OutputDocument_MeetingClone_Description: "-",
  OutputDocument_MeetingClone_Title: "Copiare la sessione",
  OutputDocument_MeetingComplete_Description: "Chiude la riunione corrente. Le opzioni di modifica sono limitate da questo momento in poi",
  OutputDocument_MeetingComplete_Title: "Chiudere la riunione",
  OutputDocument_MeetingEdecide_Description: "Crea una attività in eDecide",
  OutputDocument_MeetingEdecide_Title: "Creare una attività eDecide",
  OutputDocument_MeetingFixate_Description: "Fissa la riunione corrente. Da questo momento in poi, i numeri dei capitoli dell'invito sono fissi",
  OutputDocument_MeetingFixate_Title: "Fissare la riunione",
  OutputDocument_MeetingInvitation_Description: "-",
  OutputDocument_MeetingInvitation_Title: "Creare un invito",
  OutputDocument_MeetingInvitationMail_Description: "Crea l'invito come modello di Outlook da inviare ai partecipanti",
  OutputDocument_MeetingInvitationMail_Title: "Inviare un invito",
  OutputDocument_MeetingOneNote_Description: "-",
  OutputDocument_MeetingOneNote_Title: "Creare un OneNote",
  OutputDocument_MeetingOverview_Description: "Crea l'elenco degli elementi ageda per i partecipanti (invito)",
  OutputDocument_MeetingOverview_Title: "Creare elenco dell'agenda",
  OutputDocument_MeetingPresentationReminderMail_Description: "Crea un modello di Outlook che può essere utilizzato per inviare un promemoria per la presentazione dei documenti",
  OutputDocument_MeetingPresentationReminderMail_Title: "Inviare promemoria presentazioni",
  OutputDocument_MeetingProtocolConfidential_Description: "Crea il protocollo in un file Word con i punti dell'ordine del giorno strettamente confidenziale",
  OutputDocument_MeetingProtocolConfidential_Title: "Creare protocollo (strettamente confidenziale)",
  OutputDocument_MeetingProtocolMail_Description: "Crea il protocollo come modello di Outlook",
  OutputDocument_MeetingProtocolMail_Title: "Invia il protocollo",
  OutputDocument_MeetingProtocolNonConfidential_Description: "Crea il protocollo come file di Word",
  OutputDocument_MeetingProtocolNonConfidential_Title: "Creare un protocollo",
  OutputDocument_MeetingReminderMail_Description: "Crea un modello di Outlook che può essere utilizzato per inviare un promemoria per la presentazione dei documenti",
  OutputDocument_MeetingReminderMail_Title: "Inviare un promemoria",
  OutputDocument_MeetingSaveAsDefault_Description: "Sovrascrive l'attuale riunione standard di questo organo con i punti all'ordine e i partecipanti applicabili a questa riunione.",
  OutputDocument_MeetingSaveAsDefault_Title: "Salva come standard",
  OutputDocument_MeetingUpdateAgendaItems_Confirm: "Tutti i punti all'ordine, ad eccezione di quelli aggiunti manualmente, vengono eliminati e viene applicato l'ordine del giorno della riunione standard.",
  OutputDocument_MeetingUpdateAgendaItems_Confirm_Title: "Aggiornare l'agenda?",
  OutputDocument_MeetingUpdateAgendaItems_Description: "Tutti i punti all'ordine, ad eccezione di quelli aggiunti manualmente, vengono eliminati e viene applicato l'ordine del giorno della riunione standard.",
  OutputDocument_MeetingUpdateAgendaItems_Title: "Aggiornare l'ordine del giorno",
  OutputDocument_MeetingUpdateParticipants_Confirm: "Tutti i partecipanti, ad eccezione di quelli aggiunti manualmente, vengono eliminati e viene applicato l'elenco dei partecipanti della riunione standard.",
  OutputDocument_MeetingUpdateParticipants_Confirm_Title: "Aggiornare i partecipanti?",
  OutputDocument_MeetingUpdateParticipants_Description: "Tutti i partecipanti, ad eccezione di quelli aggiunti manualmente, vengono eliminati e vengono applicati i partecipanti della riunione standard.",
  OutputDocument_MeetingUpdateParticipants_Title: "Aggiornare l'elenco dei partecipanti",
  OutputDocument_Name: "Documento di uscita",
  OutputDocument_Task_Description: "Aprire compiti",
  OutputDocument_Task_Title: "Aprire compiti",
  OutputDocument_WorkingDocumentsExportFolders_Description: "Crea un archivio con tutti i documenti di lavoro della riunione corrente.",
  OutputDocument_WorkingDocumentsExportFolders_Title: "Esportare documenti di lavoro (zip)",
  OutputDocuments_Button_AgendaItem: "Punto all'ordine attuale",
  OutputDocuments_Button_Meeting: "Riunione in corso",
  OutputDocuments_Empty: "Non è stato generato nessun documento.",
  OutputDocuments_FolderUrl: "I seguenti documenti sono stati creati con successo",
  OutputDocuments_Header: "Generazione di documenti",
  OutputDocuments_Loading: "Creare documenti …",
  OutputDocuments_Success: "Salvato con successo",
  OutputDocuments_Table_Name: "Nome del documento",
  OutputDocuments_Table_Size: "Dimensione",
  Owner: "Possessore",
  Page_About_Title: "Su SiVe",
  Page_Admin_Title: "Amministrazione",
  Page_Administration_Title: "Amministrazione",
  Page_AgendaItem_Title: "Punto «{0}»",
  Page_AgendaItems_Title: "Punti",
  Page_Board_Title: "Organo «{0}»",
  Page_BoardCache_Title: "Cache del organo",
  Page_BoardEdit_Title: "Modifica il organo «{0}»",
  Page_Boards_Title: "Organi",
  Page_BoardSetup_Title: "Impostazione del organo",
  Page_BoardTemplates_Title: "Modelli dell'organo",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "User claims",
  Page_Dashboard_Description: "Nella dashboard vengono visualizzate le prossime riunioni di tutte le organi in cui si è autorizzati. Il periodo di visualizzazione (impostazione predefinita da oggi meno 10 giorni) può essere modificato utilizzando il filtro data. Tutte le organi e le riunioni visualizzate possono essere richiamate facendo clic su di esse.",
  Page_Dashboard_Title: "Dashboard",
  Page_Default_Title: "Sommario",
  Page_DetailedDashboard_Title: "Panoramica delle riunioni e dei punti all'ordine",
  Page_Document_Title: "Documento",
  Page_Documents_Title: "Documenti",
  Page_Error_SubTitle: "Si è verificato un errore durante l'elaborazione della vostra richiesta.",
  Page_Error_Title: "Errore",
  Page_Group_Title: "Gruppo «{0}»",
  Page_Groups_Title: "Gruppi",
  Page_Impersonate_Title: "Adottare un'identità",
  Page_JobStatus_Title: "Stato del lavoro",
  Page_Mails_Title: "Test Inxmail",
  Page_Meeting_Title: "Riunione",
  Page_MeetingName_Title: "Meeting  «{0}»",
  Page_Meetings_Title: "Riunioni",
  Page_Memory_Title: "Memoria",
  Page_OneDriveSync_Title: "Sincronizzazione OneDrive",
  Page_Participant_Title: "Partecipante «{0}»",
  Page_Participants_Title: "Partecipanti",
  Page_Resources_Title: "Traduzioni",
  Page_SendTo_Title: "Inviare a",
  Page_Settings_Title: "Configurazioni",
  Page_Setup_Title: "Impostazi",
  Page_SignOut_Title: "Disconnessione",
  Page_StandardMeetingName_Title: "Riunione standard «{0}»",
  Page_StaticCache_Title: "Cache statica",
  Page_Task_Title: "Compito «{0}»",
  Page_Tasks_Title: "Compiti",
  Page_Translations_Title: "Traduzioni",
  Page_User_Title: "Utente «{0}»",
  Page_UserEdit_Title: "Modifica l'utente «{0}»",
  Page_UserPreferences_Title: "Preferenze",
  Page_Users_Title: "Utenti",
  Pagination_First: "Inizio",
  Pagination_Last: "Ultimo",
  Pagination_Next: "Successivo",
  Pagination_Previous: "Precedente",
  Paging_First: "Inizio",
  Paging_Items: "dati",
  Paging_Last: "Ultimo",
  Paging_Next: "Successivo",
  Paging_Of: "di",
  Paging_OutOfBounds: "I parametri (skip*take) superano il numero di risultati disponibili.",
  Paging_Page: "Pagine",
  Paging_Previous: "Precedente",
  Paging_SkipTooLarge: "I parametri (skip*take) superano il numero di risultati disponibili.",
  Paging_TotalFiltered1: "1 elemento",
  Paging_TotalFilteredN: "{0} elementi",
  Paging_TotalUnfiltered: "(filtrati da {0} elementi totali)",
  PagingFirst: "Inizio",
  PagingLast: "Ultimo",
  PagingNext: "Successivo",
  PagingPrevious: "Precedente",
  Participant: "Partecipante",
  Participant_Add_ContextHelp_Title: "-",
  Participant_Add_Description: "-",
  Participant_Add_Submitting: "Creare partecipanti …",
  Participant_Add_Success: "Il partecipante sono stato aggiunto",
  Participant_CanSeeConfidential_Description: "Selezionare se il partecipante può vedere i documenti confidenziali",
  Participant_CanSeeConfidential_Title: "Mostrare documenti strettamente confidenziali",
  Participant_Loading: "Caricamento il partecipante …",
  Participant_Loading_EditForm: "Caricamento del modulo dei partecipanti …",
  Participant_NavBar_AddParticipant: "Aggiungere",
  Participant_NavBar_ToggleNav: "Mostra/nascondi la navigazione",
  Participant_Person_Title: "Persona",
  Participant_Position_Description: "-",
  Participant_Position_Title: "Posizione",
  Participant_Remarks_Description: "Commenti sui partecipanti",
  Participant_Remarks_Title: "Osservazione",
  Participant_Remove_Success: "Il partecipante è stato eliminato",
  Participant_Role_Description: "Selezionare qui Presidente o Protocollo. Il ruolo Membro è memorizzato per impostazione predefinita.",
  Participant_Role_Title: "Ruolo",
  Participant_Status_Description: "Seleziona lo stato del partecipante",
  Participant_Status_Title: "Stato",
  Participant_User_Description: "Seleziona un membro del organo",
  Participant_User_Title: "Persona",
  ParticipantRole_Chair: "Presidenza",
  ParticipantRole_NoDataTemplate: "Nessun ruolo trovato",
  ParticipantRole_Placeholder: "Seleziona il ruolo …",
  ParticipantRole_Protocol: "Protocollo",
  Participants: "Partecipanti",
  Participants_Description: "Contiene i partecipanti al organo",
  Participants_Loading: "Caricamento dei partecipanti …",
  Participants_NavBar_View: "Vista",
  Participants_Title: "Partecipanti",
  ParticipantsDetail_Empty: "Selezionare un partecipante",
  ParticipantsList_Empty: "Nessun partecipante è stato registrato",
  ParticipantStatus_Deleted: "Cancellato",
  ParticipantStatus_Excused: "Dispensato",
  ParticipantStatus_Present: "Presente",
  ParticipantStatus_Unexcused: "Non dispensato",
  ParticipantStatus_Unknown: "Sconosciuto",
  Permission_Add_Error: "Non è stato possibile aggiungere l'autorizzazione: {0}",
  Permission_Add_Success: "L'autorizzazione è stata aggiunta",
  Permission_Remove_Error: "Non è stato possibile eliminare l'autorizzazione: {0}",
  Permission_Remove_Success: "L'autorizzazione è stata eliminata",
  Permissions: "Autorizzazioni",
  Personalisation: "Personalizzazione",
  PersonalSiteUrl: "URL del sito MySite di SharePoint (OneDrive)",
  PersonnelNumber: "Nr. personale",
  Phone: "Telefono",
  Phonebook: "Elenco telefonico",
  PhonebookLastSync: "Ultima sincronizzazione",
  Placeholder: "carattere di rimpiazzamento",
  Properties: "Caratteristiche",
  PublishedDocuments: "Documenti pubblicati",
  PublishedDocuments_Description: "Contiene i documenti pubblicati del organo.",
  PublishingDocuments_Tooltip: "-",
  ReadMore_Less: "Mostra meno …",
  ReadMore_More: "Mostra di più …",
  RequestId: "Richiesta ID",
  RichText_Link_Dialog_Title: "Modifica link",
  RichText_Link_Invalid_URL: "Inserisci un URL valido (https://, http://, mailto:)",
  RichText_Link_Remove: "Rimuovi link",
  RichText_Link_Text_Label: "Testo visualizzato",
  RichText_Link_URL_Label: "Destinazione",
  RichText_Paste_Cancel_Tooltip: "Annulla (annulla incolla)",
  RichText_Paste_KeepFormatting_Tooltip: "Mantieni la formattazione",
  RichText_Paste_Options_Trigger_Tooltip: "Opzioni di incolla (Ctrl)",
  RichText_Paste_PlainText_Tooltip: "Incolla come testo normale",
  Richtext_Placeholder: "Inserire testo …",
  RichText_Tooltip_Background: "Colore di sfondo",
  RichText_Tooltip_Blockquote: "Applicare il formato di giustificazione",
  RichText_Tooltip_Bold: "Grassetto (Ctrl+B)",
  RichText_Tooltip_Clean: "Cancellare il formato",
  RichText_Tooltip_Color: "Colore del testo",
  RichText_Tooltip_Heading: "Intestazione",
  RichText_Tooltip_Indent_Minus1: "Ridurre la gestione (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Aumentare la gestione (Tab)",
  RichText_Tooltip_Italic: "Corsivo (Ctrl+I)",
  RichText_Tooltip_Link: "Aggiungi un link",
  RichText_Tooltip_List_Bullet: "Aggiungere un elenco",
  RichText_Tooltip_List_Ordered: "Aggiungere un elenco numerato",
  RichText_Tooltip_Script_Sub: "Sottoscritto",
  RichText_Tooltip_Script_Super: "Superscritto",
  RichText_Tooltip_Size: "Dimensione del testo",
  RichText_Tooltip_Source: "Visualizza sorgente HTML",
  RichText_Tooltip_Strike: "Barrato",
  RichText_Tooltip_Underline: "Sottolineatura (Ctrl+U)",
  Run: "Attività",
  Runs: "Attività",
  Save: "Salvare",
  SelectAll: "Seleziona tutti",
  Selected_Actions: "Azioni selezionate",
  SendTo_Add_Error: "Non è stato possibile aggiungere la connessione: {0}",
  SendTo_Add_Success: "La connessione è stata aggiunta",
  SendTo_AddIncoming: "Aggiungi organo di provenienza",
  SendTo_AddOutgoing: "Aggiungere un organo di destinazione",
  SendTo_Incoming: "Connessioni in entrata",
  SendTo_Outgoing: "Connessioni in uscita",
  SendTo_Remove_Error: "Non è stato possibile eliminare la connessione: {0}",
  SendTo_Remove_Success: "La connessione è stato eliminato",
  SendtoPanel_Committee: "Organo",
  SendtoPanel_Description: "Selezionare uno o più organi di destinazione e le relative riunioni ed eseguire l'azione con Invia.",
  SendtoPanel_Header: "Inviare a",
  SendtoPanel_Loading: "Caricamento delle organi …",
  SendtoPanel_Meeting: "Riunione",
  SendToPanel_Meeting_NoDataTemplate: "Nessuna riunione trovata",
  SendToPanel_Meeting_Placeholder: "Selezionare la riunione …",
  SendtoPanel_Submit: "Inviare",
  SendtoPanel_Submitting: "Inviare i punti all'ordine agli organi eletti …",
  SendtoPanel_Success: "I punti all'ordine sono stati inviati con successo.",
  SendtoPanel_Title: "Aiuto per Invia a",
  SendToTargets: "Invia a organi di destinazione",
  ShortName: "Nome breve",
  ShowDeleted: "Mostra le voci cancellate",
  ShowInactive: "Mostra le voci inattive",
  ShowPermissions: "Mostra le autorizzazioni",
  SignatureFirstName: "Nome",
  SignatureFirstName_Undefined: "L'impostazione Nome della firma non è definita nel organo!",
  SignatureLastName: "Cognome",
  SignatureLastName_Undefined: "L'impostazione 'Cognome della firma' non è definita nel organo!",
  StandardAgendaItems: "Punti all'ordine standard",
  StandardMeeting_Apply_Error: "Non è stato possibile applicare la riunione standard: {0}",
  StandardMeeting_Apply_Success: "La riunione standard è stata applicata con successo.",
  StandardMeeting_Empty: "Vuoto",
  StandardMeeting_Old: "Vecchio modello (sarà cancellato a breve!)",
  StandardMeetingsPanel_Description: "Selezionare una riunione standard e applicare gli attributi della riunione, gli elementi dell'ordine del giorno e i partecipanti alla riunione esistente. Vengono offerte solo le riunioni il cui attributo “È standard” è attivato (vedere la scheda “Riunione”).",
  StandardMeetingsPanel_Header: "Applicare la riunione standard",
  StandardMeetingsPanel_Preview_Loading: "Scarica l'anteprima …",
  StandardMeetingsPanel_Submit: "Applicare",
  StandardParticipants: "Partecipanti standard",
  Statistics: "Statistiche",
  Statistics_Loading: "Caricamento statistiche…",
  Status: "Stato",
  StatusCode_401_SubTitle: "Non hai accesso alla risorsa.",
  StatusCode_401_Title: "Accesso negato",
  StatusCode_403_SubTitle: "Non hai i permessi per accedere alla risorsa.",
  StatusCode_403_Title: "Proibito",
  StatusCode_404_SubTitle: "Non hai accesso alla risorsa.",
  StatusCode_404_Title: "Non trovato",
  SuggestedAgendaItem_MeetingId_Title: "Riunione",
  SuggestedAgendaItems: "Punti all'ordine presentati",
  SuggestedAgendaItems_Delete: "Cancellare",
  SuggestedAgendaItems_Delete_Success: "Gli elementi selezionati sono stati cancellati.",
  SuggestedAgendaItems_Deleting: "Elementi selezionati eliminati …",
  SuggestedAgendaItems_Description: "Contiene i punti all'ordine presentati dal organo",
  SuggestedAgendaItems_Filter: "Limitare",
  SuggestedAgendaItems_Loading: "Caricamento dei punti all'ordine suggeriti …",
  SuggestedAgendaItems_Meeting: "Riunione",
  SuggestedAgendaItems_Meeting_Tooltip: "La proposta di riunione del punto all'ordine presentato. Si tratta di una nota informale della persona che ha presentato il punto all'ordine. Le voci selezionate vengono sempre aggiunte alla riunione in corso.",
  SuggestedAgendaItems_Move: "Aggiungere",
  SuggestedAgendaItems_Move_Success: "Gli elementi selezionati sono stati aggiunti alla riunione corrente.",
  SuggestedAgendaItems_Selection: "-",
  SuggestedAgendaItems_Selection_Tooltip: "Qui è possibile selezionare le voci dell'ordine presentate. Le azioni Aggiungi e Elimina possono essere applicate alle voci selezionate.",
  SuggestedAgendaItems_Submitting: "Gli elementi selezionati vengono aggiunti alla riunione corrente …",
  SuggestedAgendaItems_Title: "Titolo",
  SuggestedAgendaItems_Title_Tooltip: "Il titolo del punto all'ordine presentato",
  SuggestedAgendaItemsPanel_Header: "Punti all'ordine presentati",
  Table: "Tabella",
  Table_NoRows: "Nessun record trovato.",
  Target: "destinazione",
  Task: "Compito",
  Task_AgendaItem_Description: "-",
  Task_AgendaItem_Title: "Punto all’ordine",
  Task_AssignedTo_Description: "-",
  Task_AssignedTo_Title: "Assegnato a",
  Task_Description_Description: "-",
  Task_Description_Title: "Descrizione",
  Task_DueDate_Description: "-",
  Task_DueDate_Title: "Data di scadenza",
  Task_Meeting_Description: "-",
  Task_Meeting_Title: "Riunione",
  Task_NavBar_AddTask: "Aggiungere",
  Task_NavBar_ToggleNav: "Mostra/nascondi la navigazione",
  Task_NotAssigned: "Non attribuito",
  Task_Source_Description: "-",
  Task_Source_Title: "Sorgente",
  Task_StartDate_Description: "-",
  Task_StartDate_Title: "Data inizio",
  Task_Status_Description: "-",
  Task_Status_Title: "Stato",
  Task_Title: "Titolo",
  Task_Title_Title: "Titolo",
  Task_Title_Tooltip: "Titolo",
  Task_Validate_IsLonger_Title: "Il campo Titolo non deve essere più lungo di 255 caratteri",
  TaskFilterToggle_Description: "Il dashboard mostra solo le compiti assegnate all'utente corrente.",
  TaskFilterToggle_Title: "Solo i miei compiti",
  TaskGrid_ItemId: "Id",
  TaskGrid_ItemId_Tooltip: "Id del compito",
  TaskList_Empty: "Non sono state rilevate compiti",
  Tasks: "Compiti",
  Tasks_Add: "Aggiungi compito",
  Tasks_Description: "Contiene le compiti del organo",
  Tasks_Loading: "Caricamento compito …",
  Tasks_Loading_EditForm: "Caricamento il modulo compito…",
  TasksDetail_Empty: "Selezionare un compito",
  TaskStatus_Archived: "Archiviato",
  TaskStatus_Complete: "Concluso",
  TaskStatus_Default: "In corso",
  TaskStatus_Deferred: "Rinviato",
  TaskStatus_InProgress: "In Bearbeitung",
  TaskStatus_NotStarted: "Non iniziato",
  TaskStatus_WaitingOnSomeoneElse: "In attesa di qualcun altro",
  TaskToggle_Description: "Visualizza le compiti per tutte le riunioni.",
  TaskToggle_Title: "Visualizzare compiti",
  Template_Remove_Error: "Non è stato possibile eliminare il modello: {0}",
  Template_Remove_Success: "Il modelo è stato eliminato",
  Templates: "Modelli",
  Templates_ValidFileNames: "Nomi di file validi",
  TemplatesDescription: "La configurazione standard dell'applicazione viene installata insieme all'applicazione dal team di sviluppo SiVe. Le correzioni ai modelli vengono quindi aggiornate automaticamente per tutte le istanze di gestione delle sessioni.",
  TenantName_Help: "Il nome del organo viene utilizzato nei modelli di documento e nell'interfaccia utente della gestione delle riunioni. I valori usuali sono il nome completo dell'organo, come Consiglio di amministrazione o Direzione del gruppo.",
  TimePicker_Hours: "Ore",
  TimePicker_Minutes: "Minuti",
  Title: "Titolo",
  Toast_Error: "Errore",
  Toast_Success: "Successo",
  Toast_Warning: "Attenzione",
  Total: "Totale",
  Upload_Choose: "Selezionare i file …",
  Upload_ClearSelectedFiles: "Rimuovere i file selezionati",
  Upload_DefaultDropZoneNote: "…",
  Upload_DropFilesHere: "Lasciate qui i file per caricarli …",
  Upload_DropZoneHint: "Lasciate qui i file per caricarli …",
  Upload_DropZoneNote: "Sono ammessi solo i file {0}.",
  Upload_Files: "File",
  Upload_HeaderStatusUploaded: "compiuto",
  Upload_HeaderStatusUploading: "Carica…",
  Upload_InvalidFileExtension: "Tipo di file non consentito.",
  Upload_InvalidFiles: "File non valido. Controllare i requisiti per il caricamento dei file.",
  Upload_InvalidMaxFileSize: "Dimensioni del file troppo grandi",
  Upload_InvalidMinFileSize: "Dimensione del file troppo piccola",
  Upload_SelectNoFilesTitle: "Premere per selezionare altri file",
  Upload_SelectTitle: "Selezionare i file…",
  Upload_StatusFailed: "Non è stato possibile caricare i file.",
  Upload_StatusUploaded: "I file sono stati scaricati con successo.",
  Upload_StatusUploadFailed: "Non è stato possibile caricare i file.",
  Upload_StatusUploading: "Verrà caricato …",
  Upload_StatusWarning: "Attenzione",
  Upload_Total: "Totale",
  Upload_UploadSelectedFiles: "Caricare i file selezionati",
  UploadFile: "File",
  Upn: "Nome principale",
  User: "Utente",
  User_AnonymizedDisplayName: "Utente eliminato",
  User_Boards: "Organi",
  User_DisplayName: "Nome",
  User_Email: "E-mail",
  User_Email_Description: "Inserire qui il proprio indirizzo e-mail.",
  User_Email_Title: "E-mail",
  User_FirstName: "Nome",
  User_FirstName_Description: "Inserire il proprio nome.",
  User_FirstName_Title: "Nome",
  User_Initials: "Iniziali",
  User_Initials_Description: "Inserire qui l'abbreviazione della persona",
  User_Initials_HelpText: `Se lasci il campo vuoto, verrà applicato il valore predefinito.<br/>
Prima lettera del nome, prima lettera del cognome.`,
  User_Initials_Preview: "Aperçu",
  User_Initials_Title: "Iniziali",
  User_Language: "Lingua",
  User_LastName: "Cognome",
  User_LastName_Description: "Inserire il proprio cognome.",
  User_LastName_Title: "Cognome",
  User_LastSync: "Ultima sincronizzazione",
  User_OrganisationUnit: "Unità organizzativa",
  User_PersonalSiteUrl: "URL del sito MySite di SharePoint (OneDrive)",
  User_PersonnelNumber: "Nr. personale",
  User_Phone: "Telefono",
  User_Status: "Stato",
  User_Sync_Error: "Non è stato possibile sincronizzare l'utente: {0}",
  User_Sync_NotSupported: "La sincronizzazione per questo utente non è supportata",
  User_Sync_Success: "L'utente è stato sincronizzato",
  User_Unknown: "Sconosciuto",
  User_Update_Error: "Non è stato possibile salvare l'utente: {0}",
  User_Update_Success: "L'utente è stato salvato",
  User_Upn: "Nome principale",
  User_UserRoles: "Ruoli",
  UserMenu_MyDetails: "Il mio profilo",
  UserMenu_SignOut: "Disconnessione",
  UserPicker: "Cerca utente",
  UserPicker_NoDataTemplate: "Nessun partecipante trovato",
  UserPicker_Placeholder: "Inserire l'identificatore …",
  UserPreferences_Description: "Configura qui le tue preferenze per la visualizzazione della gestione delle riunioni. Se le tue autorizzazioni non includono la visualizzazione di elementi cancellati, ad esempio, l'impostazione corrispondente non ha alcun effetto.",
  UserRole_Administrator: "Amministratore",
  UserRole_Application: "Applicazione",
  UserRole_BoardOwner: "Possessore dell'organo",
  UserRole_Unknown: "Utente",
  UserRole_User: "Sconosciuto",
  UserRoles: "Ruoli",
  Users: "Utente",
  UserSettings: "Configurazioni",
  UserStatus_Deleted: "Cancellato",
  UserStatus_Enabled: "Attivo",
  UserStatus_Unknown: "Sconosciuto",
  Validation_Board_CannotArchiveWithActiveMeetings: "Il comitato non può essere archiviato perché ci sono ancora riunioni attive.",
  Validation_Board_NameAlreadyUsed: "Esiste già un comitato con questo valore ({0}, {1})",
  Validation_Date_MustBeEarlierThan: "Il valore del campo '{0}' deve essere precedente al valore del campo '{1}'.",
  Validation_Date_YearAtLeast: "'{0}' (anno) deve essere maggiore o uguale a {1}.",
  Validation_Document_ContentBytesEmpty: "Il file '{0}' caricato ha una lunghezza non valida di 0 byte.",
  Validation_Document_FileNameEmpty: "Il file caricato non deve avere un nome vuoto.",
  Validation_Document_IsProtected: "Il file caricato «{0}» è stato riconosciuto come crittografato, motivo: {1}.",
  Validation_Field_ConcurrentDashes: "'{0}' non può contenere più trattini consecutivi.",
  Validation_Field_EndsWithDashes: "'{0}' non può terminare con trattini.",
  Validation_Field_InvalidCharacters: "'{0}' contiene caratteri non validi ('{1}', posizione: {2}).",
  Validation_Field_LeadingOrTrailingWhitespace: "'{0}' non può contenere spazi all’inizio o alla fine.",
  Validation_Field_MustBeGreaterThanZero: "'{0}' deve avere un valore superiore a 0, è {1}.",
  Validation_Field_MustBeSameAs: "'{0}' ({1}) deve contenere lo stesso valore di '{2}' ({3}).",
  Validation_Field_MustNotBeEmpty: "'{0}' non può essere vuoto.",
  Validation_Field_NotInValidNames: "'{0}' non contiene alcun nome valido.",
  Validation_Field_StartsWithDashes: "'{0}' non può iniziare con i trattini.",
  Validation_Participant_AlreadyExists: "Esiste già un partecipante '{0}' in questa riunione.",
  ValidationFailures: "Errore di validazione",
  View_AgendaItems_Details: "Dettagli",
  View_AgendaItems_Overview: "Sommario",
  View_AgendaItems_Protocol: "Protocollo",
  View_Documents_Grid: "Sommario",
  View_OneDriveSync_Overview: "Sincronizzazione di OneDrive",
  View_Participants_Details: "Dettagli",
  View_Participants_Overview: "Sommario",
  View_Tasks_Overview: "Sommario",
  View_Views_Edit: "Modifica",
  Visitor: "Visitatori",
  WorkingDocument: "Documento di lavoro",
  WorkingDocument_FileExtension: "Estensione del file",
  WorkingDocument_FileName: "Nome del file",
  WorkingDocument_FileSize: "Dimensione",
  WorkingDocument_StorageUrl: "Url del blob",
  WorkingDocument_UniqueId: "Id unico",
  WorkingDocuments: "Documenti di lavoro",
  WorkingDocuments_Add_Button: "Caricare un documento",
  WorkingDocuments_Description: "Contiene i documenti di lavoro del organo",
  WorkingDocuments_Tooltip: "Aprire la cartella corrispondente nei documenti di lavoro.",
  Yes: "Sì",
};
